import { ref } from 'vue'
import { defineStore } from 'pinia'

const STORE_KEY = 'protargeting-user-activity'

export const useUserActivityStore = defineStore(STORE_KEY, () => {
  const audienceCreatorQueryId = ref<number>()

  return { audienceCreatorQueryId }
})
